import { Http } from 'sparnord-utils'

export default class Initiatives extends Http.AbstractModel {
  static get _id () {
    return 'dd775f99-f558-4100-9b5b-09bb647d22ee?depth=3'
  }

  static get endpoint () {
    return `/${Initiatives._id}`
  }

  static async get () {
    let instance = await this.find(Initiatives._id)
    return instance.item.properties.initiativer.map(item => new Initiatives(item))
  }

  get year () {
    return parseInt(this.item.properties.arstal || 0, 10)
  }

  get amount () {
    return this.item.properties.beloeb
  }

  get count () {
    return this.item.properties.initiativer
  }

  get title () {
    return this.item.properties.titel
  }

  get description () {
    return this.item.properties.tekst
  }
}



// WEBPACK FOOTER //
// ./src/models/initiatives.js